import { render, staticRenderFns } from "./updateBRLModal.vue?vue&type=template&id=3d4815c4&"
import script from "./updateBRLModal.vue?vue&type=script&lang=js&"
export * from "./updateBRLModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports